module.exports = __webpack_public_path__ + "img/ring_g_i_1_0@3x.35308904.png";